import { TParsedVersion } from '../types/items.types';

/**
 * Given a version ID like "5.1" or "draft", returns major/minor or
 * a flag if it's "draft".
 */
function parseVersionId(versionId: string): TParsedVersion {
  if (versionId === 'draft') {
    // We can treat "draft" as a very large version so that it is >= any numeric version
    return { major: 999999, minor: 999999, isDraft: true }; // unfortunately, we can't use Infinity here
  }
  const [major, minor] = versionId.split('.').map(Number);
  return { major, minor, isDraft: false };
}

/**
 * Compares two version IDs that have been parsed. Returns:
 *   > 0 if a > b
 *   0   if a == b
 *   < 0 if a < b
 */
const compareVersionIds = (versionIdA: string, versionIdB: string): number => {
  const parsedA = parseVersionId(versionIdA);
  const parsedB = parseVersionId(versionIdB);
  if (parsedA.major !== parsedB.major) return parsedA.major - parsedB.major;
  return parsedA.minor - parsedB.minor;
};

const isGreaterThan = (versionIdA: string, versionIdB: string) => {
  return compareVersionIds(versionIdA, versionIdB) > 0;
};
const isLessThan = (versionIdA: string, versionIdB: string) => {
  return compareVersionIds(versionIdA, versionIdB) < 0;
};
const isGreaterEqualThan = (versionIdA: string, versionIdB: string) => {
  return compareVersionIds(versionIdA, versionIdB) >= 0;
};
const isLessEqualThan = (versionIdA: string, versionIdB: string) => {
  return compareVersionIds(versionIdA, versionIdB) <= 0;
};

const compareVersion = {
  isGreaterThan,
  isLessThan,
  isGreaterEqualThan,
  isLessEqualThan,
};

export default compareVersion;
